import { render } from "./RequirementPart.vue?vue&type=template&id=fa4b8e5e&scoped=true"
import script from "./RequirementPart.vue?vue&type=script&lang=js"
export * from "./RequirementPart.vue?vue&type=script&lang=js"

import "./RequirementPart.vue?vue&type=style&index=0&id=fa4b8e5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4b8e5e"]])

export default __exports__